import React, { useState } from 'react';
import { useModalStore } from '../../stores/useUIStore';
import { useAdminStore } from '../../stores/adminStore';
import toast from 'react-hot-toast';

const SendWarningModal = ({ userId, username }) => {
  const closeModal = useModalStore((state) => state.closeModal);
  const sendWarning = useAdminStore((state) => state.sendWarning);
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) {
      toast.error('El mensaje no puede estar vacío.');
      return;
    }
    setIsSubmitting(true);
    const success = await sendWarning(userId, message);
    if (success) {
      closeModal();
    }
    setIsSubmitting(false);
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-xl w-full max-w-lg">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">Enviar Advertencia a {username}</h2>
      <form onSubmit={handleSubmit}>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Escribe el motivo de la advertencia..."
          rows="5"
          className="w-full p-2 border rounded-md"
          required
        ></textarea>
        <div className="flex justify-end space-x-3 mt-4">
          <button type="button" onClick={closeModal} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">
            Cancelar
          </button>
          <button type="submit" disabled={isSubmitting} className="px-4 py-2 bg-yellow-500 text-white rounded-md hover:bg-yellow-600 disabled:bg-yellow-300">
            {isSubmitting ? 'Enviando...' : 'Enviar Advertencia'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SendWarningModal;